import { render, staticRenderFns } from "./DetailTaxPph4Verse2.vue?vue&type=template&id=6dbb3e2b"
import script from "./DetailTaxPph4Verse2.vue?vue&type=script&lang=js"
export * from "./DetailTaxPph4Verse2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports